// This file can be replaced during build by using the `fileReplacements` array.
// `gn build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// https://api.intelligens.in/api/base-url?app_version=1.0&device_type=android
export const environment = {
  baseUrl: "https://api.intelligens.in/lambdaweb/",
  production: false,
  cookieUrl: "https://api.intelligens.in/cookies/",
  localUrl: "https://api.intelligens.in/api/",
  apiUrl: "https://api.intelligens.in/api/",
  apiBaseUrl: "https://api.intelligens.in/users/",
  serverApiUrl: "https://api.intelligens.in/api/",
  planApiUrl:
    "https://api.intelligens.in/payment/",
  authApiUrl: "https://api.intelligens.in/auth/",
  uploadApiUrl:
    "https://api.intelligens.in/image/",
  imgPreview: "https://d1tcjcrle6fjgd.cloudfront.net/",
  secretkey: "a1b2c3d4e5f6g7h8i9h0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6",
  videoUrl: "./../assets/videos/",
  imageUrl: "./../assets/images/",
  headerImgUrl: "assets/images/logo-white.svg",
  userNoImage: "assets/images/user.jpg",
  monthPlanId: "price_1HQ9FTA8lqZeqjmXmdky8SjM",
  yearPlanId: "price_1HxAtjA8lqZeqjmXfKJZVbO3",
  premiumPlanId: "price_1Hx9f4A8lqZeqjmXoRIoAgA3",
  superPlanId: "price_1HQ9GkA8lqZeqjmXfiAp46y7",
  publicKey:
    "pk_test_51HNVNzA8lqZeqjmXjTZrygeYuSxBtPatJdUysoOcIHxcFo58WXw1OqcWtxK0nMPGCKZjfmosdtxBvVBl8UnnxYR100xSiXZT9K",
  reCaptchaKey: "6Ldm6q8eAAAAAH4OI3M_pGMTPYS5HdtyrdeGVYtY",
  facebookAppId: "944294012759044",
  facebookSecretId: "c5c4142f18c40023eea4850621e519d0",
  googleClientId:
    "524247974863-q3h8c844tlrhhidt5duiqkaf56vv9149.apps.googleusercontent.com",
  googleClientIosId: "",

  // Placeholder images path.
  musicActiveIcon: "assets/images/audio-sound.svg",
  portraitDefault: "assets/images/2-3-portrait.png",
  landscapeDefault: "assets/images/16-9-landscape.png",
  squareDefault: "assets/images/1-1-square.png",
  bannerDefault: "assets/images/16-4-banner.png",
  posterDefault: "assets/images/16-9-poster.png",
  localStorageKey: "app_v2",
  localStorageLangKey: "app_language",
  videoStorage: "videojs",
  tabStorage: "is_vedio_play",
  pagesLocalStorageKey: "app_data",
  dobFormat: "MM/dd/yyyy",
  genresDefault: "assets/images/genres.jpg",
  BrowserNotSupported: "assets/images/BrowserNotSupported.png",
  shareUrl: "https://sharing.intelligens.in/",
  analyticsStatus: false,
  themeClass: "",
  oneSignalId: "58c46a29-99c6-4840-b52c-6c3be246b791",
  playListImg: "assets/images/playlist .png",
  firebaseConfig: {
    apiKey: "AIzaSyAjd6NuUvIu6EaEv-gcaUQ7qs5PLLaRK2o",
    authDomain: "ideal-chat-ddfd8.firebaseapp.com",
    databaseURL: "https://ideal-chat-ddfd8-default-rtdb.firebaseio.com",
    projectId: "ideal-chat-ddfd8",
    storageBucket: "ideal-chat-ddfd8.appspot.com",
    messagingSenderId: "480825872778",
    appId: "1:480825872778:web:487b3c34b236625277b873",
    measurementId: "G-5NZTLJZTZB",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
